module.exports = __webpack_public_path__ + "img/ontology.8ef96689.png";